import type { ClienteApi } from '../cliente';
import { claveIdempotencia } from '../comun';
import type { components } from '../tipos/plataforma';

type Esquema<N extends keyof components['schemas']> = components['schemas'][N];

export type InvitacionPublica = Esquema<'InvitationPublic'>;
export type CuentaNueva = Esquema<'AccountCreate'>;
export type MiembroDelEquipo = Esquema<'Member'>;

const enlace = (token: string): `/v1/${string}` => `/v1/invitations/${encodeURIComponent(token)}`;

/** Operaciones de aceptar una invitación (1.10), con su `operationId` y los tipos generados del contrato. */
export function operacionesInvitacion(api: ClienteApi) {
    return {
        /** getInvitationByToken (anónima): negocio, quien invita, roles, estado y caducidad. */
        getInvitationByToken: (token: string) => api.pedir<InvitacionPublica>('GET', enlace(token), { sinSesion: true }),
        /** acceptInvitation (con sesión): crea la membership con los roles de la invitación; `403 invitation_email_mismatch` si es otra cuenta. */
        acceptInvitation: (token: string, clave = claveIdempotencia()) => api.pedir<MiembroDelEquipo>('POST', `${enlace(token)}/accept`, { idempotencia: clave }),
        /**
         * createAccount (alta pública, `X-Captcha-Token` de reCAPTCHA v3, G76): con `invitation_token` y el email invitado,
         * la cuenta nace con el email verificado (G173). 202 sin cuerpo: después se entra con createSession.
         */
        createAccount: (datos: CuentaNueva, captcha: string | null, clave = claveIdempotencia()) =>
            api.pedir<undefined>('POST', '/v1/auth/accounts', {
                cuerpo: datos,
                idempotencia: clave,
                sinSesion: true,
                cabeceras: captcha === null ? {} : { 'X-Captcha-Token': captcha },
            }),
    };
}
